export default "https://raw.githubusercontent.com/bedicooper/studioKosmos-clone/main/src/features/Portfolio/thumbnails/";